import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  remainingWorkDays: number
  totalWorkedDays: number
  total: number
  year: number
}

const DailyCounter = ({ year, totalWorkedDays, remainingWorkDays, total }: Props) => {
  const box = (title: number, subTitle: string, lastItem = false) => (
    <Box
      justifyContent="flexEnd"
      alignItems="center"
      paddingX="s32"
      border={{
        right: {
          color: lastItem ? 'grey000White' : 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
    >
      <Text color="grey1000" size="500" weight="medium">
        {title}
      </Text>
      <Text color="grey600" size="100" weight="semibold">
        {subTitle.toUpperCase()}
      </Text>
    </Box>
  )

  return (
    <Box
      flexDirection="row"
      justifyContent="center"
      paddingY="s24"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs004',
      }}
    >
      {box(
        total,
        i18n.t('clock_in.planned', {
          year,
        })
      )}
      {box(
        totalWorkedDays,
        i18n.t('clock_in.worked', {
          year,
        })
      )}
      {box(
        remainingWorkDays,
        i18n.t('clock_in.balance', {
          year,
        }),
        true
      )}
    </Box>
  )
}

export default observer(DailyCounter)
